module.exports = __webpack_public_path__ + "img/logo1.e395ee43.png";